<div mat-dialog-content>
    <lgv-loading-indicator *ngIf="(isUploading$ | async) || (isLoading$ | async)"></lgv-loading-indicator>

    <!--<div class="alert alert-warning">
        <div>typeIdField.value: {{typeIdField.value}}</div>

        <div *ngIf="selectedTask">
            <div>selectedTask?.id: {{selectedTask?.id}}</div>
            <div>selectedTask?.name: {{selectedTask?.name}}</div>
        </div>
        <div>readyToSubmit: {{readyToSubmit}}</div>
        <div>selectedFileName: {{selectedFileName}}</div>
        <div class="Vert-15"></div>
        <div>Task List:</div>
        <div *ngFor="let t of taskList">{{t.name}}</div>
    </div>-->

    <h4 *ngIf="isAddMode">Add Task</h4>
    <h4 *ngIf="isEditMode">Edit Task</h4>
    <h4 *ngIf="isUploadDocumentMode">Upload Document</h4>
    <div class="Vert-15"></div>


    <ng-container *ngIf="isAddMode || isEditMode">
        <form [formGroup]="_taskForm">
            <div class="row">

                <ng-container *ngIf="lgvLoanAppSvc.assignableTaskTypes$ | async as taskTypes">
                    <mat-form-field appearance="outline" floatLabel="always" class="col-12" title="Request Type"
                        formGroupName="type">
                        <mat-label>Request Type</mat-label>
                        <mat-select formControlName="id" placeholder="Request Type">
                            <mat-option *ngFor="let item of taskTypes" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="lgvLoanAppSvc.taskItemsForType$(typeIdField.value) | async as taskItems">
                    <mat-form-field appearance="outline" floatLabel="always" class="col-12" title="Document"
                        formGroupName="item">
                        <mat-label>Document</mat-label>
                        <mat-select formControlName="id" placeholder="Document">
                            <mat-option *ngFor="let item of taskItems" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
                <ng-container *ngIf="isCreditReportSelected$ | async">
                    <mat-form-field appearance="outline" floatLabel="always" class="col-12" title="Request Type"
                        formGroupName="creditReportType">
                        <mat-label>Report Type</mat-label>
                        <mat-select formControlName="id" placeholder="Report Type">
                            <mat-option *ngFor="let item of lgvLoanAppSvc.creditReportTypes$ | async" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
                <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                    <mat-label>Name</mat-label>
                    <input type="text" matInput formControlName="name">
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                    <mat-label>Description</mat-label>
                    <input type="text" matInput formControlName="description">
                </mat-form-field>

            </div>
        </form>
    </ng-container>

    <ng-template *ngIf="isUploadDocumentMode && filteredTaskList?.length == 0">
        There are no tasks for this Loan Application
    </ng-template>

    <ng-container *ngIf="isUploadDocumentMode && filteredTaskList.length > 0">
        <div class="row">
            <div class="col-12">Task</div>
            <mat-form-field appearance="outline" class="col-12">
                <!-- Use *ngIf with an else clause on the <mat-select> to handle empty lists -->
                <mat-select [(ngModel)]="selectedTask" (selectionChange)="onTestSelection($event.value)">
                    <mat-option *ngFor="let t of filteredTaskList" [value]="t">{{ t.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <ng-container *ngIf="!selectedFile">
            <button class="btn btn-secondary" type="button" (click)="fileInput.click()">Choose File</button>
            <input hidden="true" class="btn btn-secondary" type="file" #fileInput multiple
                accept="image/*, .doc, application/pdf, .DOC, .DOCM, .DOCX, .DOT, .DOTM, .DOTX, .RTF, .TXT, .ODT, .OTT, .XLSX, .XLSB, .XLS2003, .XLT, .XLTX, .XLTM, .XLAM, .ODS, .TSV, .CSV, .XLS, .XLSM, .PDF, .XPS, .MSG, .EML, .EMLX"
                (change)="fileChangeEvent($event)" required>
        </ng-container>

        <div class="Vert-15"></div>
        <div *ngIf="selectedFile?.length > 0">
            <ul *ngFor="let file of selectedFile">
                <li>{{file.name}}</li>
            </ul>
        </div>
        <div *ngIf="!selectedFile">
            No file selected.
        </div>

        <div class="Vert-15"></div>

        <div class="lgv-progress-bar" *ngIf="isUploading$ | async">
            <mat-progress-bar mode="determinate" [value]="uploadProgress$ | async"></mat-progress-bar>
            <div>{{(uploadProgress$ | async) >= 100 ? 'Processing...' : 'Uploading...'}}</div>
        </div>

        <ng-container *ngIf="(uploadProgress$ | async) >= 100 && !(isUploading$ | async)">
            <div>Finished Uploading</div>
        </ng-container>

    </ng-container>

    <div class="Vert-15"></div>
    <div class="row">
        <div class="col-12" align="end">
            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                [disabled]="!readyToSubmit || (isUploading$ | async) || (isLoading$ | async)">
                <span *ngIf="isAddMode">Add</span>
                <span *ngIf="isEditMode">Update</span>
                <span *ngIf="isUploadDocumentMode"
                    [disabled]="isUploadDocumentMode && filteredTaskList.length == 0">Upload</span>
            </button>
            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                style="margin-right:10px;"> Cancel </button>
        </div>
    </div>
</div>